import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateUserContact, IUser, UserListResponse, UserQueryParams } from '@frontend/user/types';

const endpoint = '/user-api/v1';

export class UserContactClient extends APIClient {
    public static async getMyContacts(queryParams?: ApiQueryParams<UserQueryParams>): Promise<UserListResponse> {
        return await this.apiPaginated<UserListResponse, UserQueryParams>(`${endpoint}/my-contacts`, queryParams);
    }
    public static async getCorporateContacts(queryParams?: ApiQueryParams<UserQueryParams>): Promise<UserListResponse> {
        return await this.apiPaginated<UserListResponse, UserQueryParams>(`${endpoint}/corporate-contacts`, queryParams);
    }
    public static async createMyContact(accountId: string, contact: CreateUserContact): Promise<IUser> {
        const res = await this.post(`${endpoint}/accounts/${accountId}/my-contacts`, contact);
        return this.handleResponse<IUser>(res);
    }
    public static async createCorporateContact(accountId: string, contact: CreateUserContact): Promise<IUser> {
        const res = await this.post(`${endpoint}/accounts/${accountId}/corporate-contacts`, contact);
        return this.handleResponse<IUser>(res);
    }
}
